import { PersonReadDataProvider } from '@aibees/elephant/context';
import { PeopleTableInfo } from '@aibees/elephant/feature/search-table-people';
import { ParentFeature } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/context';
import { ContactDetailsProvider } from '@aibees/elephant/feature/search-table-people/components/people-drawer/components/contact-details/context/provider';
import { PeopleEmailPopover } from '@aibees/elephant/feature/search-table-people/components/people-email-popover';
import { Maybe } from '@aibees/shared/definition';
import { useMemo } from 'react';
import { AiAnalysisContent } from '../../ai-analysis-content';
import { ProfileDetailsPopover } from '../components/profile-details-popover';
import { QUICK_INFO_BUTTONS } from '../components/quick-info-button';
import { PeoplePhoneNumberPopover } from '@aibees/elephant/feature/search-table-people/components/people-phone-number-popover';

export function useGetPeopleQuickInfoPopoverContent(
  id: Maybe<QUICK_INFO_BUTTONS>,
  data: PeopleTableInfo,
  isOpen: boolean
) {
  return useMemo(() => {
    if (!isOpen || !id) return null;
    if (id === QUICK_INFO_BUTTONS.EMAIL_ENRICHMENT)
      return <PeopleEmailPopover item={data} />;
    if (id === QUICK_INFO_BUTTONS.PHONENUMBER_ENRICHMENT)
      return <PeoplePhoneNumberPopover data={data} />;
    if (id === QUICK_INFO_BUTTONS.CONTACT_ENRICHMENT)
      return (
        <PersonReadDataProvider id={data.id}>
          <ContactDetailsProvider
            parentFeature={ParentFeature.QUICK_INFO_CONTACT_DETAILS_POPOVER}
          >
            <ProfileDetailsPopover personTableData={data} />
          </ContactDetailsProvider>
        </PersonReadDataProvider>
      );
    if (id === QUICK_INFO_BUTTONS.PERSONALITY_ANALYSIS)
      return (
        <PersonReadDataProvider id={data.id}>
          <AiAnalysisContent isPopover />
        </PersonReadDataProvider>
      );
    return null;
  }, [id, data, isOpen]);
}
